<svg width="443" height="275" viewBox="0 0 443 275" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M443 275H0V0H443V275ZM70 33C63.3726 33 58 38.3726 58 45V230C58 236.627 63.3726 242 70 242H373C379.627 242 385 236.627 385 230V45C385 38.3726 379.627 33 373 33H70Z" fill="black"/>
</svg>
